<template>
    <el-dialog
        class="login-dialog"
        :visible.sync="showLoginDialog"
        width="450px"
        :close-on-click-modal="false"
        @closed="activeLoginMode = 'mobile'"
    >
        <div class="login-con z-flex z-flex-col z-flex-center">
            <img class="logo" src="@/assets/images/logo2.png"/>
            <!-- <div class="slogan">欢迎来到五六公社</div> -->
            <div class="hd-tab z-flex" v-if="activeLoginMode!='bind'">
                <div :class="['item',activeLoginMode=='mobile'?'active':'']" @click="changeMode('mobile')">手机号登录</div>
                <el-divider direction="vertical"></el-divider>
                <div :class="['item',activeLoginMode=='weixin'?'active':'']" @click="changeMode('weixin')">微信登录</div>
                <el-divider direction="vertical"></el-divider>
                <div :class="['item',activeLoginMode=='pswd'?'active':'']" @click="changeMode('pswd')">密码登录</div>
            </div>
            <div class="hd-tab" v-else>
                <div class="item" style="cursor:default;color: #333;">绑定手机号</div>
            </div>
            <!-- 验证码登录 -->
            <div class="bd" v-show="activeLoginMode=='mobile'">
                <el-form class="form" ref="form" :model="form">
                    <el-form-item class="item">
                        <el-input v-model="form.mobile" placeholder="请输入手机号码" clearable>
                            <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="item item-smscode">
                        <el-input v-model="form.smscode" placeholder="请输入短信验证码">
                            <i slot="prefix" class="el-input__icon el-icon-message"></i>
                            <div class="send-sms-wrap" slot="suffix">
                                <el-divider direction="vertical"></el-divider>
                                <span class="btn-sendsms" @click="sendSms" v-if="countdown==0">发送验证码</span>
                                <span class="btn-sendsms btn-sendsms-ing" v-else><em>{{countdown}}s</em>后重新获取</span>
                            </div>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="item">
                        <el-checkbox v-model="form.autoLog">下次自动登录</el-checkbox>
                    </el-form-item>
                    <el-form-item class="item">
                        <el-button class="btn-login" type="primary" :loading="loginBtnLoading" @click="login">立即登录
                        </el-button>
                    </el-form-item>
                    <div class="tips">
                        <i class="el-icon-warning"></i>
                        新手机号将自动注册，已详细阅读并同意
                        <a href="javascript:void(0)" @click="toUrl('/agreement',true)">《五六公社用户协议》</a>
                    </div>
                </el-form>
            </div>
            <!-- 微信登录 -->
            <div class="bd z-flex z-flex-col z-flex-center" v-show="activeLoginMode=='weixin'">
                <div class="tips">打开微信扫描下方二维码</div>
                <div id="login_container"><img class="qrcode" src="https://www.pai2345.com/static/web/res/images/code.png"/></div>
                <div class="tips">
                    <i class="el-icon-warning"></i>
                    未注册账号将自动注册，已详细阅读并同意
                    <a href="javascript:void(0)" @click="toUrl('/agreement',true)">《五六公社用户协议》</a>
                </div>
            </div>
            <!-- 绑定手机号 -->
            <div class="bd z-flex z-flex-col z-flex-center" v-show="activeLoginMode=='bind'">
                <el-form class="form" ref="form" :model="form">
                    <el-form-item class="item">
                        <el-input v-model="form.mobile" placeholder="请输入手机号码" clearable>
                            <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="item item-smscode">
                        <el-input v-model="form.smscode" placeholder="请输入短信验证码">
                            <i slot="prefix" class="el-input__icon el-icon-message"></i>
                            <div class="send-sms-wrap" slot="suffix">
                                <el-divider direction="vertical"></el-divider>
                                <span class="btn-sendsms" @click="sendSms" v-if="countdown==0">发送验证码</span>
                                <span class="btn-sendsms btn-sendsms-ing" v-else><em>{{countdown}}s</em>后重新获取</span>
                            </div>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="item">
                        <el-button class="btn-login" type="primary" :loading="loginBtnLoading" @click="login">立即绑定</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 密码登录 -->
            <div class="bd" v-show="activeLoginMode=='pswd'">
                <el-form class="form" ref="form" :model="form">
                    <el-form-item class="item">
                        <el-input v-model="form.mobile" placeholder="请输入手机号码" clearable>
                            <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="item">
                        <el-input v-model="form.password" type="password" placeholder="请输入密码" clearable>
                            <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="item">
                        <el-checkbox v-model="form.autoLog">下次自动登录</el-checkbox>
                    </el-form-item>
                    <el-form-item class="item">
                        <el-button class="btn-login" type="primary" :loading="loginBtnLoading" @click="passwordLogin">立即登录
                        </el-button>
                    </el-form-item>
                    <div class="tips">
                        <i class="el-icon-warning"></i>
                        新手机号将自动注册，已详细阅读并同意
                        <a href="javascript:void(0)" @click="toUrl('/agreement',true)">《五六公社用户协议》</a>
                    </div>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {mapState, mapActions} from "vuex";
    export default {
        name: "loginCom",
        props: {},
        data() {
            return {
                showLoginDialog: false,
                activeLoginMode: 'mobile',
                form: {
                    unionid: '',
                    mobile: '',
                    smscode: '',
                    autoLog: true,
                    password:'',
                },
                countdown: 0,//倒计时
                timer: null,
                loginBtnLoading: false,
            };
        },
        mounted() {
            window.addEventListener('message', (event) => {
                // console.log('addEventListener---', event)
                switch(event.data.act) {
                    case 'loginWeChatCallback':
                        this.$axios.api.request({
                            url: "/api/qtclub/wechat/qrcodeLogin",
                            data: {
                                unionid: event.data.loginData.unionid
                            }
                        }, (res) => {
                            if (res.data.action == 'bind') {
                                // 手机号绑定
                                this.activeLoginMode = 'bind';
                                this.form.unionid = res.data.user.unionid;
                            } else if (res.data.action == 'login') {
                                // 扫码登录
                                localStorage.setItem('token', res.data.token);
                                this.getLoginUserInfo();
                                this.$message.success('登录成功！');
                                this.showLoginDialog = false;
                            }
                            // console.log("qrcodeLogin----", res)
                        })
                        break;
                }
            })
        },
        computed: {
            ...mapState(['vuex_user'])
        },
        methods: {
            ...mapActions(['vuexUserLogin', 'vuexUserLogout', 'vuexInitLocalUser']),
            toUrl(url,blank) {
                if(blank){
                    let routeData = this.$router.resolve(url);
                    window.open(routeData.href, '_blank');
                }else{
                    this.$router.push({
                        path: url,
                    })
                }
            },
            changeMode(mode) {
                this.activeLoginMode = mode;
                if (mode == 'weixin') {
                    var wxobj = new WxLogin({
                        self_redirect:true,
                        id:"login_container",
                        appid: process.env.VUE_APP_WECHATOFFICIALAPPID,
                        scope: "snsapi_login",
                        redirect_uri: encodeURIComponent(process.env.VUE_APP_WECHAT_AUTH_URL),
                        state: "8f6397e1e156",
                    });
                }
            },
            //发送验证码
            sendSms() {
                if (this.form.mobile.trim() == '') {
                    return this.$message.error('请输入手机号！');
                }
                const countNum = 60;
                if (!this.timer) {
                    this.countdown = countNum;
                    this.timer = setInterval(() => {
                        if (this.countdown > 0 && this.countdown <= countNum) {
                            this.countdown--;
                        } else {
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000)
                    this.$axios.api.request({
                        data: {mobile: this.form.mobile},
                        url: "/api/qtclub/user/sendLoginCode",
                    }, (res) => {
                        if (res.code != 200) {
                            this.$message.error('短信发送失败，请稍后尝试！');
                            clearInterval(this.timer);
                            this.timer = null;
                            this.countdown = 0;
                        }
                    })
                }
            },
            //账号密码登录
            passwordLogin() {
                if (this.form.mobile.trim() == '') {
                    return this.$message.error('请输入手机号！');
                }
                if (this.form.password.trim() == '') {
                    return this.$message.error('请输入密码！');
                }
                this.loginBtnLoading = true;
                this.$axios.api.request({
                    data: this.form,
                    url: "/api/qtclub/user/passwordLogin",
                }, (res) => {
                    this.loginBtnLoading = false;
                    if (res.code == 200) {
                        this.$message.success('登录成功！');
                        this.showLoginDialog = false;
                        localStorage.setItem('token', res.data.token);
                        this.getLoginUserInfo();
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //手机号登录 / 微信登陆绑定
            login() {
                if (this.form.mobile.trim() == '') {
                    return this.$message.error('请输入手机号！');
                }
                if (this.form.smscode.trim() == '') {
                    return this.$message.error('请输入短信验证码！');
                }
                // console.log("---", this.form)
                this.loginBtnLoading = true;
                this.$axios.api.request({
                    data: this.form,
                    url: "/api/qtclub/user/mobileLogin",
                }, (res) => {
                    this.loginBtnLoading = false;
                    if (res.code == 200) {
                        this.$message.success('登录成功！');
                        this.showLoginDialog = false;
                        localStorage.setItem('token', res.data.token);
                        this.getLoginUserInfo();
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            },
            getLoginUserInfo(callback){
                this.$axios.api.getUserInfo({}, (res) => {
                    if (res.code == 200) {
                        let user = {
                            id: res.data.id,
                            avatar: res.data.avatar,
                            username: res.data.nickname,
                            vipName: res.data.vip_name,
                            vipExpiration: res.data.limit_date,
                            qtclubWinStar: res.data.qtclub_win_star,
                            qtclubWinStarName: res.data.qtclub_win_star_name,
                            qtclubWinPopup: res.data.qtclub_win_popup
                        };
                        this.vuexUserLogin(user);
                    }
                    if (typeof callback == 'function') {
                        callback(res.data);
                    }
                });
            }
        },
    };
</script>

<style lang="scss" scoped>
    .login-dialog {
        display: flex;
        justify-content: center;
        align-items: center;

        ::v-deep .el-dialog {
            margin: 0 auto !important;
        }

        ::v-deep .el-dialog__body {
            padding: 20px 40px 30px;
        }

        .logo {
            width: 90px;
            border-radius: 20px;
        }

        .slogan {
            font-size: 25px;
            font-weight: 700;
            color: #333;
            margin-top: 20px;
            letter-spacing: 2px;
        }

        .hd-tab {
            margin-top: 30px;
            // width: 100%;
            .el-divider {
                margin: 0 20px;
            }

            .item {
                text-align: center;
                font-size: 18px;
                font-weight: 700;
                color: #999;
                padding: 5px 0;
                cursor: pointer;
                position: relative;

                &.active {
                    color: #333;

                    &::after {
                        content: "";
                        width: 40px;
                        height: 5px;
                        border-radius: 3px;
                        display: block;
                        background: $colorMain;
                        position: absolute;
                        bottom: -5px;
                        left: 50%;
                        margin-left: -20px;
                    }
                }
            }
        }

        .bd {
            width: 100%;
            margin-top: 30px;

            .tips {
                color: #999;

                a {
                    color: $colorMain;
                }

                .el-icon-warning {
                    color: $colorYellow;
                    font-size: 16px;

                }
            }

            .item-smscode {
                ::v-deep .el-input__inner {
                    padding-right: 140px;
                }

                .btn-sendsms {
                    padding: 0 10px 0 0;
                    cursor: pointer;
                    color: $colorMain;
                }

                .btn-sendsms-ing {
                    color: #999;

                    em {
                        color: $colorMain;
                        font-style: normal;
                        margin-right: 3px;
                    }
                }
            }

            ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
                color: #666;
            }

            .qrcode {
                width: 280px;
                margin: 10px 0;
            }
        }

        .btn-login {
            width: 100%;
        }
    }
</style>
